const nl = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Naam ontdekkingsbron',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'Gebruikers-ID',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'URL Service Now',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Wachtwoord',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Ongeldige URL',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Frequentie van ontdekking',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Vraag gebruikers om vragen over kennisgebaseerde authenticatie (KBA) te beantwoorden.',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Ontdek uw apps en taken via een van deze ontdekkingsbronnen. U krijgt dan voordelen zoals vooraf ingevulde gegevens, aanbevelingen op basis van prioriteit en een volledig overzicht van de onboardingstatus.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Terug',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Ontdekking instellen',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Binnenkort beschikbaar...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Meer informatie',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Voer uw applicatiegegevens in om een verbinding tot stand te brengen. Zodra de verbinding tot stand is gebracht, kunt u gegevens importeren.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Er is een fout opgetreden tijdens het laden van de pagina.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Probeer opnieuw te laden of kom later terug. Neem contact op met uw beheerder als het probleem zich blijft voordoen.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Opnieuw laden',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Verbindingsinstellingen',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI-klassen***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Kenmerktoewijzing',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Verbindingsdetails',
  'INTEGRATIONS.BUTTON.SAVE': 'Opslaan',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Selecteren',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Nieuwe verbinding maken',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Deze verbinding gebruiken',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow opgeslagen!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Uw verbinding met de ontdekkingsbron ServiceNow is getest en opgeslagen. Importeer gegevens om de ontdekking af te ronden. U kunt dit overslaan...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Assets importeren',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Nu overslaan',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Zodra het importeren is gestart, kan het niet meer worden geannuleerd.',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Help mij',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Bestaande verbinding selecteren',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Naam van verbinding',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'We hebben {total, plural, one {een} other {#}} bestaande verbindingsconfiguratie ontdekt:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Importeren starten',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Gegevens importeren uit Excel-bestand. Even geduld a.u.b...',
  'INTEGRATIONS.TRY.AGAIN': 'Probeer het nog eens',
  'INTEGRATIONS.CLOSE': 'Sluiten',
  'INTEGRATIONS.ERROR.CONNECTION': 'Verbindingsfout. Probeer het opnieuw.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'U kunt de pagina verlaten terwijl u wacht. Wij zullen u op de hoogte brengen zodra het proces is voltooid.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Ontdekkingsbron importeren',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Importeer uw ontdekkingsbron vanuit een bestand.',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Voorbeeldbestand downloaden',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Naam ontdekkingsbron',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Bestandsnaam invoeren',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Voer een geldige naam in. Alleen letters, cijfers en bepaalde symbolen zijn toegestaan.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Bezig met uploaden...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Verdergaan',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Hieronder vindt u de eerste 10 records uit het geüploade XLSX-bestand.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Verplichte koptekst ontbreekt',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Kolomfouten gedetecteerd',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Los de problemen op voordat u doorgaat met het importeren van gegevens.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Uitsluiten van import',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Bevestiging applicatie van onboarding',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'We hebben het type applicatie geïdentificeerd. Bevestig of dit het juiste type applicatie is dat u wilt onboarden.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'Het type applicatie dat u aan het onboarden bent is {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Nee, selecteer uit een lijst met applicaties',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'Ja, ik ben aan het onboarden',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integraties',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Integratie toevoegen',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Geen resultaten gevonden voor',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Geen',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'integraties gevonden.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'Geen verborgen integraties beschikbaar.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Ontdekte applicaties',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Eigenaar:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Laatst ontdekt op',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Verbinding mislukt',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Gebruikers hebben toegang',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Ontdekkingsbron',
  'INTEGRATIONS.BUTTON.ENABLE': 'Inschakelen',
  'INTEGRATIONS.BUTTON.DISABLE': 'Uitzetten',
  'INTEGRATIONS.ENABLING': 'Inschakelen',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Ontdekking',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Opnieuw uploaden',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Onboarden',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Verbergen',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Weergeven',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'Configuratietabbladen weergeven',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Onopgeslagen wijzigingen verwijderen?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'U hebt onopgeslagen wijzigingen. Wijzigingen gaan verloren als u doorgaat.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Wijzigingen verwijderen',
  'INTEGRATIONS.BUTTON.CANCEL': 'Annuleren',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Fout opslaan',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': 'Terug naar vorige pagina',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Pictogram applicatie',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Handmatig uitvoeren',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': 'Uitschakelen mislukt',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'Inschakelen mislukt',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Uitgeschakeld.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION': 'Ingeschakeld.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Er wordt momenteel een andere import uitgevoerd.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Assets worden momenteel geïmporteerd door een ander proces. Probeer het later opnieuw.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'Importeren is mislukt',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': 'Assets importeren van ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'U kunt de pagina verlaten terwijl u wacht. Wij zullen u op de hoogte brengen zodra het proces is voltooid.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Een nieuwe rij voor kenmerktoewijzing toevoegen',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Attribuut toevoegen',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Leeg)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Deze toewijzing verwijderen',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow-veld',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt-veld',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'ServiceNow-kenmerk zoeken',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Saviynt-kenmerk zoeken',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Aangepast)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Opslaan is mislukt',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Planning configureren',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'Op {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Herhalen op',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Herhalen op dagen',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Herhalen om de',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Interval invoeren',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Herhaal interval in aantal dagen, weken of maanden',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Dag',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Week/weken',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Maand',
  'INTEGRATIONS.DAYS.SUN': 'Zo.',
  'INTEGRATIONS.DAYS.MON': 'Ma.',
  'INTEGRATIONS.DAYS.TUE': 'Di.',
  'INTEGRATIONS.DAYS.WED': 'Wo.',
  'INTEGRATIONS.DAYS.THU': 'Do.',
  'INTEGRATIONS.DAYS.FRI': 'Vr.',
  'INTEGRATIONS.DAYS.SAT': 'Za.',
  'INTEGRATIONS.BUTTON.DISABLING': 'Uitzetten',
  'INTEGRATIONS.BUTTON.SAVED': 'Opgeslagen',
  'INTEGRATIONS.BUTTON.SAVING': 'Bezig met opslaan',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE':
    'Weet u zeker dat u wilt uitzetten ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'Door de ontdekkingsbron uit te schakelen, wordt het importeren van assets gestopt en kunt u de bron niet meer configureren.',
  'INTEGRATIONS.DISCOVERY.HERE': 'hier',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Uw ontdekkingsbron is aangemaakt, maar de verbinding met ServiceNow is mislukt. Om te beginnen met het importeren van assets, dient u de verbindingsgegevens op de configuratiepagina van de ontdekkingsbron bij te werken. ',
};

export default nl;
